import { useEffect, useState } from 'react';
import { getCloudIds } from '@agilytics/utils/jira';
import { useAgilyticsState, useAgilyticsDispatch } from '@agilytics/global-state';

export default function useCloudIds() {
  const { accessToken, cloudIds } = useAgilyticsState();
  const [stateCloudIds, setCloudIds] = useState(cloudIds);

  const dispatch = useAgilyticsDispatch();

  useEffect(() => {
    if (accessToken) {
      const fetchCloudIds = async () => {
        const cloudIds = await getCloudIds(accessToken);
        if (cloudIds) {
          dispatch({ type: 'updateCloudIds', cloudIds });
          setCloudIds(cloudIds);
        }
      };

      fetchCloudIds();
    }
  }, [accessToken, dispatch, setCloudIds]);

  return stateCloudIds;
}
